<template>
  <div>
    <el-dialog title="支付提醒"
               :mask-closable="false"
               :close-on-click-modal="false"
               :visible.sync="payShow"
               :close-on-press-escape="false"
               :show-close="false"
               width="400"
               :styles="{ top: '100px' }">
      <div>
        <!-- <div v-show="payData"
               class="pay-success">
            <svg aria-hidden="true"
                 class="pay-icon">
              <use xlink:href="#iconchenggong"></use>
            </svg>
            <div>恭喜您支付成功! 前往订单中心可查询已购产品</div>
          </div> -->
        <div class="flexEnd"
             style="margin-top:-60px">
          <i class="el-icon-close font20"
             style="cursor: pointer;"
             @click="hanldeClose"></i>
        </div>
        <div class="flexCenter">
          <div style="flex:1">
            <div class="pay-time">
              <div class="font20"
                   style="font-weight:600">请使用 <span class="mainColor">微信扫一扫</span> 扫描二维码支付 </div>
              <div class="flexCenter"
                   v-if="remainTime!=0"
                   style="margin:10px 0;font-family: 'bb';">
                支付倒计时: <span class="mainColor">{{remainTime}}</span>
              </div>
              <div class="pay-qrcode"
                   id="parentNode">
                <div class="qrcode"
                     ref="qrCodeUrl"></div>
              </div>
              <div class="product-pay-item flexCenter">
                <img src="http://storage.360buyimg.com/payment-assets/sdk/bank/PAY-WEIXIN.png"
                     alt=""
                     style="width:26px;height:26px;;margin-right:4px;"><span style="font-size:16px">微信支付</span>
              </div>
            </div>
          </div>
          <div style="flex:1">
            <img style="width:100%"
                 src="http://storage.360buyimg.com/payment-assets/pc/icon/phone-bg.png"
                 alt="">
          </div>
        </div>
      </div>
      <span slot="footer">
      </span>
      <el-dialog width="30%"
                 title="关闭提醒"
                 :visible.sync="innerVisible"
                 :show-close="false"
                 :center="true"
                 append-to-body>
        <div>
          <div class="flexCenter">请确认没有正在支付中的订单，支付完成前请不要关闭该窗口</div>
          <div class="flexCenter"
               style="margin:20px 0">
            <el-button style="margin-right:20px"
                       @click="close">仍然离开</el-button>
            <el-button type="danger"
                       @click="innerVisible = false">我知道了</el-button>
          </div>
          <div class="flexCenter">
            <el-image style="width:150px;height:150px"
                      :src="url"></el-image>
            <div style="margin-left:20px">
              {{data.showIndex == 16?'下载App畅享精彩课程':'微信扫码添加您的学习顾问，获取一对一服务噢！'}}
            </div>
          </div>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
// import QRCode from 'qrcodejs2'
// import Vue from "vue"
// import QRCode from "qrcode"
// Vue.use(QRCode)
import QRCode from 'qrcodejs2'
import {
  getOrderStatusByOrderNo, resourceList
} from "@/api/api";

export default {
  data () {
    return {
      innerVisible: false,
      payShow: false,
      payData: false,
      payDialogLoading: true,
      qrcode: "",
      orderNo: "",
      remainTime: 0,
      data: {
        showIndex: 17,  //16为app下载
        pageNumber: 1,
        pageSize: 100,
      },
      url: ''
    }
  },
  methods: {
    // 创建支付二维码  || "https://iviewui.com/components/spin"
    creatQrCode (text, orderNo, showIndex) {
      console.log(text)
      this.data.showIndex = showIndex;
      this.orderNo = orderNo;
      this.payShow = true;
      this.getresourceList()
      this.$nextTick(() => {
        const h = document.getElementById("parentNode").offsetHeight
        console.log(QRCode)
        this.qrcode = new QRCode(this.$refs.qrCodeUrl, {
          text: text,
          width: 200,
          height: 200,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        });
        this.queryState();
      })
    },
    // 轮询付款结果
    queryState () {
      this.timer = setInterval(() => {
        getOrderStatusByOrderNo({
          orderNo: this.orderNo
        }).then(res => {
          if (res.code == 0) {
            // 订单完成
            if (res.result[0].orderStatus == 2) {
              if (this.timer) {
                clearInterval(this.timer)
                this.timer = null;
                this.$emit('wechatPaySuccess');
              }
            }
            if (res.result[0].remainTime > 0) {
              this.remainTime = this.formatSeconds(res.result[0].remainTime)
            } else {
              if (this.timer) {
                clearInterval(this.timer)
                this.timer = null;
                this.$emit('orderStatusClose');
              }
            }
            // 订单关闭
            if (res.result[0].orderStatus == 0) {
              if (this.timer) {
                clearInterval(this.timer)
                this.timer = null;
                this.$emit('orderStatusClose');
              }
            }
          }
        })
        // this.$http({
        //   url: this.$http.vaUrl('/native/payQuery/state'),
        //   method: 'post',
        //   params: this.$http.adornParams({
        //     'tradeNo': this.tradeNo,
        //   })
        // }).then(({ data: res }) => {
        //   if (res.code === 0) {
        //     this.payData = res
        //     if (this.timer) {
        //       clearInterval(this.timer)
        //       this.timer = null
        //       this.curIndex = -999
        //     }
        //   }
        // })
      }, 1000);
    },
    //  秒数转化为时分秒
    formatSeconds (value) {
      //  秒
      let second = parseInt(value)
      //  分
      let minute = 0
      //  小时
      let hour = 0
      //  天
      //  let day = 0
      //  如果秒数大于60，将秒数转换成整数
      if (second > 60) {
        //  获取分钟，除以60取整数，得到整数分钟
        minute = parseInt(second / 60)
        //  获取秒数，秒数取佘，得到整数秒数
        second = parseInt(second % 60)
        //  如果分钟大于60，将分钟转换成小时
        if (minute > 60) {
          //  获取小时，获取分钟除以60，得到整数小时
          hour = parseInt(minute / 60)
          //  获取小时后取佘的分，获取分钟除以60取佘的分
          minute = parseInt(minute % 60)
          //  如果小时大于24，将小时转换成天
          //  if (hour > 23) {
          //    //  获取天数，获取小时除以24，得到整天数
          //    day = parseInt(hour / 24)
          //    //  获取天数后取余的小时，获取小时除以24取余的小时
          //    hour = parseInt(hour % 24)
          //  }
        }
      }

      let result = '' + parseInt(second) + '秒'
      if (minute > 0) {
        result = '' + parseInt(minute) + '分' + result
      }
      if (hour > 0) {
        result = '' + parseInt(hour) + '小时' + result
      }
      //  if (day > 0) {
      //    result = '' + parseInt(day) + '天' + result
      //  }
      // console.log('result：', result)
      return result
    },
    async getresourceList () {  //获取资源
      const res = await resourceList(this.data)
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      this.url = res.data[0].resourceUrl
    },
    // 关闭模态框
    hanldeClose (action, bool) {
      this.innerVisible = true
      // if (!bool) {
      //   // this.$emit('close');
      //   if (this.timer) {
      //     clearInterval(this.timer)
      //     this.timer = null
      //   }
      // }
    },
    close () {
      this.$emit('close');
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  }
}
</script>

<style lang="less" scoped>
.pay-time {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  // cursor: pointer;
  .pay-qrcode {
    margin: 20px 0;
    padding: 4px;
    border: 2px solid #eee;
    .qrcode {
      width: 200px;
      height: 200px;
      margin: 0 auto;
    }
  }
}
.dialog-footer {
  text-align: center;
}
</style>